var map = {
	"./ABW.gif": 28211,
	"./AFG.gif": 86759,
	"./AGO.gif": 79848,
	"./ALB.gif": 89512,
	"./AND.gif": 27496,
	"./ARE.gif": 82373,
	"./ARG.gif": 44403,
	"./ARM.gif": 84429,
	"./AUS.gif": 20298,
	"./AUT.gif": 97073,
	"./AZE.gif": 18637,
	"./BDI.gif": 80648,
	"./BEL.gif": 71046,
	"./BEN.gif": 15224,
	"./BFA.gif": 52822,
	"./BGD.gif": 88044,
	"./BGR.gif": 5238,
	"./BHR.gif": 2875,
	"./BHS.gif": 73746,
	"./BIH.gif": 19470,
	"./BLR.gif": 48527,
	"./BLZ.gif": 20855,
	"./BMU.gif": 69567,
	"./BOL.gif": 78444,
	"./BRA.gif": 8930,
	"./BRB.gif": 67549,
	"./BRN.gif": 91617,
	"./BTN.gif": 35475,
	"./BWA.gif": 30817,
	"./CAF.gif": 62825,
	"./CAN.gif": 88705,
	"./CDF.gif": 48570,
	"./CHE.gif": 31521,
	"./CHL.gif": 94576,
	"./CHN.gif": 15134,
	"./CIV.gif": 50785,
	"./CMR.gif": 42537,
	"./COD.gif": 17973,
	"./COG.gif": 54874,
	"./COK.gif": 5470,
	"./COL.gif": 97789,
	"./COM.gif": 26468,
	"./CPV.gif": 87630,
	"./CRI.gif": 783,
	"./CUB.gif": 27969,
	"./CYM.gif": 68446,
	"./CYP.gif": 53875,
	"./CZE.gif": 51955,
	"./DEU.gif": 53353,
	"./DJI.gif": 23024,
	"./DNK.gif": 12874,
	"./DOM.gif": 15179,
	"./DZA.gif": 47736,
	"./ECU.gif": 97246,
	"./EGY.gif": 10190,
	"./ESP.gif": 41947,
	"./EST.gif": 85191,
	"./ETH.gif": 17658,
	"./EUR.gif": 55895,
	"./FIN.gif": 64360,
	"./FJI.gif": 4558,
	"./FRA.gif": 26686,
	"./GAB.gif": 16905,
	"./GBR.gif": 65452,
	"./GEO.gif": 93328,
	"./GHA.gif": 29713,
	"./GIN.gif": 32765,
	"./GMB.gif": 28429,
	"./GNB.gif": 72080,
	"./GNQ.gif": 95143,
	"./GRC.gif": 43109,
	"./GRD.gif": 198,
	"./GTM.gif": 4329,
	"./GUM.gif": 12334,
	"./GUY.gif": 34146,
	"./HKG.gif": 24949,
	"./HND.gif": 9589,
	"./HRV.gif": 89983,
	"./HTI.gif": 14526,
	"./HUN.gif": 90578,
	"./IDN.gif": 75092,
	"./IND.gif": 39664,
	"./IRL.gif": 93116,
	"./IRN.gif": 89210,
	"./IRQ.gif": 28153,
	"./ISL.gif": 34099,
	"./ISR.gif": 18569,
	"./ITA.gif": 75183,
	"./JAM.gif": 38955,
	"./JOR.gif": 97734,
	"./JPN.gif": 72335,
	"./KAZ.gif": 37101,
	"./KEN.gif": 79189,
	"./KGZ.gif": 50231,
	"./KHM.gif": 88353,
	"./KIR.gif": 13341,
	"./KNA.gif": 62427,
	"./KOR.gif": 2727,
	"./KWT.gif": 59717,
	"./LAO.gif": 563,
	"./LBN.gif": 10203,
	"./LBR.gif": 41871,
	"./LBY.gif": 14032,
	"./LCA.gif": 96035,
	"./LIE.gif": 82533,
	"./LKA.gif": 539,
	"./LSO.gif": 59321,
	"./LUX.gif": 55092,
	"./LVA.gif": 54644,
	"./MAC.gif": 86802,
	"./MAR.gif": 63307,
	"./MCO.gif": 21152,
	"./MDA.gif": 32691,
	"./MDG.gif": 47153,
	"./MDV.gif": 88328,
	"./MEX.gif": 29881,
	"./MHL.gif": 29962,
	"./MKD.gif": 12727,
	"./MLI.gif": 62947,
	"./MLT.gif": 14030,
	"./MNE.gif": 51349,
	"./MNG.gif": 71971,
	"./MOZ.gif": 64969,
	"./MRT.gif": 16456,
	"./MUS.gif": 10390,
	"./MWI.gif": 80598,
	"./MYS.gif": 75050,
	"./NAM.gif": 60975,
	"./NER.gif": 48528,
	"./NGA.gif": 27917,
	"./NIC.gif": 2149,
	"./NLD.gif": 62201,
	"./NOR.gif": 95626,
	"./NPL.gif": 36917,
	"./NRU.gif": 96074,
	"./NZL.gif": 11331,
	"./OMN.gif": 63369,
	"./PAK.gif": 68539,
	"./PAN.gif": 32718,
	"./PER.gif": 9886,
	"./PHL.gif": 75679,
	"./PLW.gif": 29164,
	"./PNG.gif": 12802,
	"./POL.gif": 38182,
	"./PRI.gif": 71916,
	"./PRK.gif": 57770,
	"./PRT.gif": 69929,
	"./PRY.gif": 82204,
	"./PSE.gif": 22243,
	"./QAT.gif": 19533,
	"./ROU.gif": 40109,
	"./RUS.gif": 85757,
	"./RWA.gif": 90289,
	"./SAU.gif": 44574,
	"./SDN.gif": 6962,
	"./SEN.gif": 27677,
	"./SGP.gif": 377,
	"./SLB.gif": 43918,
	"./SLE.gif": 3853,
	"./SLV.gif": 95746,
	"./SMR.gif": 97689,
	"./SOM.gif": 532,
	"./SRB.gif": 72992,
	"./SSD.gif": 50737,
	"./STP.gif": 23704,
	"./SUR.gif": 7681,
	"./SVK.gif": 70613,
	"./SVN.gif": 54536,
	"./SWE.gif": 67764,
	"./SWZ.gif": 25167,
	"./SYC.gif": 39340,
	"./SYR.gif": 84917,
	"./TCD.gif": 84718,
	"./TGO.gif": 85301,
	"./THA.gif": 17118,
	"./TJK.gif": 94382,
	"./TKM.gif": 13591,
	"./TLS.gif": 17516,
	"./TON.gif": 97972,
	"./TTO.gif": 31080,
	"./TUN.gif": 46598,
	"./TUR.gif": 57282,
	"./TUV.gif": 92958,
	"./TWN.gif": 64428,
	"./TZA.gif": 2312,
	"./UGA.gif": 72358,
	"./UKR.gif": 64149,
	"./URY.gif": 89541,
	"./USA.gif": 47186,
	"./UZB.gif": 87850,
	"./VEN.gif": 61876,
	"./VGB.gif": 22186,
	"./VIR.gif": 6308,
	"./VNM.gif": 83270,
	"./VUT.gif": 93642,
	"./WSM.gif": 82452,
	"./XAF.gif": 25982,
	"./XCD.gif": 79842,
	"./XOF.gif": 19272,
	"./XPF.gif": 78441,
	"./YEM.gif": 40152,
	"./ZAF.gif": 90348,
	"./ZMB.gif": 52756,
	"./ZWE.gif": 79901,
	"./money.gif": 95395
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 49030;